import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import CsLineIcons from "../../cs-line-icons";
import NotificationItem from "./item";
import {
    get as getNotifications,
    read as readNotification,
    readAll as readAllNotifications,
} from "../../actions/notification";
import "./style.css";

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showing: Boolean(props.showing),
        };
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.onDocumentMouseDown);
        this.props.getNotifications();
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.onDocumentMouseDown);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.showing !== this.props.showing && this.props.showing !== undefined) {
            this.setState({ showing: Boolean(this.props.showing) });
        }
    }

    onDocumentMouseDown = (event) => {
        if (!this.state.showing || this.wrapperRef.current?.contains(event.target)) return;
        this.setState({ showing: false });
    };

    onToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState((previous) => ({ showing: !previous.showing }));
    };

    onRead = async (uuid) => {
        if (!uuid) return;
        await this.props.readNotification(uuid);
    };

    onReadAll = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await this.props.readAllNotifications(this.props.items.map((item) => item.uuid));
    };

    onFooterClick = () => {
        this.setState({ showing: false });
    };

    renderPanel = () => {
        const { items } = this.props;
        const count = items.length;
        const caption = count === 1 ? "1 new notification" : `${count} new notifications`;

        return (
            <div
                className={`notification-dropdown dropdown-menu dropdown-menu-end${this.state.showing ? " show" : ""}`}
                role="region"
                aria-label="Notification menu"
            >
                <header className="notification-dropdown-header">
                    <div className="notification-dropdown-title">
                        {count ? caption : "No new notifications"}
                    </div>
                </header>
                <div className="notification-dropdown-body">
                    <button
                        type="button"
                        className="notification-dropdown-action"
                        onClick={this.onReadAll}
                        disabled={!count}
                    >
                        Mark all as read
                    </button>
                    <div className="notification-dropdown-divider" />
                    {count ? (
                        <div className="notification-scroll">
                            <ul className="notification-list list-unstyled">
                                {items.map((item) => (
                                    <NotificationItem
                                        key={item.uuid}
                                        id={item.uuid}
                                        style={item.style}
                                        title={item.title}
                                        description={item.description}
                                        activeDate={item.activeDate}
                                        onRead={this.onRead}
                                    />
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div className="notification-empty">You&apos;re all caught up.</div>
                    )}
                    <Link
                        to="/dashboard/notifications"
                        className="notification-footer-link"
                        onClick={this.onFooterClick}
                    >
                        See all notifications
                    </Link>
                </div>
            </div>
        );
    };

    render() {
        const count = this.props.items.length;

        return (
            <li ref={this.wrapperRef} className="list-inline-item notification-nav-item">
                <button
                    type="button"
                    className="notification-button"
                    aria-label={count ? `Notifications, ${count} unread` : "Notifications"}
                    aria-expanded={this.state.showing}
                    aria-haspopup="true"
                    onClick={this.onToggle}
                >
                    <span className="position-relative d-inline-flex">
                        <CsLineIcons icon="bell" size="18" />
                        {count ? <span className="position-absolute notification-dot rounded-xl" /> : null}
                    </span>
                </button>
                {this.renderPanel()}
            </li>
        );
    }
}

Notifications.defaultProps = {
    items: [],
    showing: undefined,
};

Notifications.propTypes = {
    items: PropTypes.array,
    showing: PropTypes.bool,
    getNotifications: PropTypes.func.isRequired,
    readNotification: PropTypes.func.isRequired,
    readAllNotifications: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    items: state.notification.items || [],
});

export { Notifications };
export default connect(mapStateToProps, {
    getNotifications,
    readNotification,
    readAllNotifications,
})(Notifications);
